module.exports = __webpack_public_path__ + "static/media/rpp.a32e7bea.png";